<template>
<div class="sezione"  style="padding:0 20px;" v-if="ready">


   <div class="yo-fixed-top" style="top:132px;z-index:999;">
   <div class="row el-container" style="background:#fff;padding:16px 20px;">
      <div class="col s8">




         <el-breadcrumb separator-class="el-icon-arrow-right" style="">
         <el-tooltip :open-delay="1200" :content="tbName" placement="bottom" effect="dark"><el-breadcrumb-item>{{labelScheda}}</el-breadcrumb-item></el-tooltip>
         <!-- <el-breadcrumb-item>Anno {{isByear}}</el-breadcrumb-item> -->
         <el-breadcrumb-item>Peso {{isBwgt[0]}}gr » {{isBwgt[1]}}gr</el-breadcrumb-item>
         <el-breadcrumb-item>EG (sett) {{isGaweeks[0]}} » {{isGaweeks[1]}}</el-breadcrumb-item>
         
         <el-breadcrumb-item v-if="isSex>-1">{{labelSex}}</el-breadcrumb-item>
         
         <el-breadcrumb-item v-if="isLocate>-1">{{labelLocate}}</el-breadcrumb-item>
         <el-breadcrumb-item v-if="isIugr>-1">{{labelIugr}}</el-breadcrumb-item>
         <el-breadcrumb-item v-if="isMult>-1">{{labelMult}}</el-breadcrumb-item>
         <el-breadcrumb-item v-if="isSga!='-1'">{{labelSga}}</el-breadcrumb-item>
         <el-breadcrumb-item v-if="isFdisp!='-1'">{{labelFdisp}}</el-breadcrumb-item>
         
         </el-breadcrumb>
      </div>
      <div class="col s4 yo-align-right">
         <div class="row">
            <div class="col s12" style="">

               <el-popover placement="top" title="Seleziona i filtri" trigger="hover">
               <i slot="reference" class="material-icons yo-pointer red" style="float:right;padding:0 12px 0 18px;" v-on:click="changeTab('filter')">filter_alt</i>
               </el-popover>  

               <el-popover placement="top" title="Trasferimento" trigger="hover">
               <i slot="reference" class="material-icons yo-pointer yo-color-primary" style="float:right;padding:0 12px 0 18px;"  v-on:click="changeTab('trasferimento')">directions_bus</i>
               </el-popover>  
               
               <el-popover placement="top" title="Dimissione" trigger="hover">
               <i slot="reference" class="material-icons yo-pointer yo-color-primary" style="float:right;padding:0 12px 0 18px;"  v-on:click="changeTab('dimissione')">child_friendly</i>
               </el-popover>  
               
               <el-popover placement="top" title="Decorso Clinico" trigger="hover">
               <i slot="reference" class="material-icons yo-pointer yo-color-primary" style="float:right;padding:0 12px 0 18px;"  v-on:click="changeTab('decorso-clinico')">hotel</i>
               </el-popover>  
               
               <el-popover placement="top" title="Sala Parto" trigger="hover">
               <img slot="reference" src="../assets/ico-salaparto.png" class="material-icons yo-pointer yo-color-primary" style="float:right;padding:0 12px 0 18px;height:24px;"   v-on:click="changeTab('sala-parto')"/>
               </el-popover>  

               <el-popover placement="top" title="Dati Perinatali" trigger="hover">
               <img slot="reference" src="../assets/ico-perinatale.png" class="material-icons yo-pointer yo-color-primary" style="float:right;padding:0 12px 0 18px;height:24px;"  v-on:click="changeTab('dati-perinatali')" />
               </el-popover>  

               <el-popover placement="top" title="Dati Generali" trigger="hover">
               <i slot="reference" class="material-icons yo-pointer yo-color-primary" style="float:right;padding:0 12px 0 18px;"  v-on:click="changeTab('dati-generali')">folder_open</i>
               </el-popover>  

            </div>

          </div>


      </div>
   </div>
   </div>

<div style="margin:22px 0 52px 0;">

<div v-if="tabShow=='filter'" >
<div class="yo-text-l  yo-color-primary">FILTRI ATTIVI</div>

<div class="row pad" style="margin-top:12px;">
<div class="col s3  yo-valign-text-center yo-align-right" style="height:40px;">Peso alla nascita</div>
<div class="col s9">
   <el-slider v-model="isBwgt" range  :marks="bwgtMarks" :min="200" :max="5000" :step="10" v-on:change="filterChange"></el-slider>
</div>
</div>

<div class="row pad" style="margin-top:24px;">
<div class="col s3 yo-valign-text-center  yo-align-right" style="height:40px;">Età gestazionale in settimane</div>
<div class="col s9">
   <el-slider v-model="isGaweeks" range  :marks="gaweeksMarks" :min="21" :max="42" v-on:change="filterChange"></el-slider>
</div>
</div>

<div class="row pad" style="margin-top:24px;">
<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Sesso</div>
<div class="col s3">
   <el-select v-model="isSex" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option label="Nessuna preferenza" :value="-1"></el-option>
    <el-option label="Femmina" :value="0"></el-option>
    <el-option label="Maschio" :value="1"></el-option>
    <el-option label="Indeterminato" :value="9"></el-option>
  </el-select>
</div>

<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Outborn / Inborn</div>
<div class="col s3">
   <el-select v-model="isLocate" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option label="Nessuna preferenza" :value="-1"></el-option>
    <el-option label="InBorn" :value="0"></el-option>
    <el-option label="OutBorn" :value="1"></el-option>
  </el-select>
</div>
</div>

<div class="row pad" style="margin-top:24px;">
<!-- eliminata dopo riunione del 18 Dicembre 2020 
<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Diagnosi di IUGR</div>
<div class="col s3">
   <el-select v-model="isIugr" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option label="Nessuna preferenza" :value="-1"></el-option>
    <el-option label="No" :value="0"></el-option>
    <el-option label="Si" :value="1"></el-option>
  </el-select>
</div>
-->

<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Gestazione multipla</div>
<div class="col s3">
   <el-select v-model="isMult" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option label="Nessuna preferenza" :value="-1"></el-option>
    <el-option label="No" :value="0"></el-option>
    <el-option label="Si" :value="1"></el-option>
  </el-select>
</div>

<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">SGA</div>
<div class="col s3">
   <el-select v-model="isSga" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option label="Nessuna preferenza" :value="-1"></el-option>
    <el-option label="< 3° percentile" value="< 3° percentile"></el-option>
    <el-option label="< 10° percentile" value="< 3° percentile,tra 3° e 10° percentile"></el-option>
    <el-option label="> 10° percentile" value="> 10° percentile,> 97° percentile"></el-option>
    <!-- <el-option label="tra 3° e 10° percentile" value="tra 3° e 10° percentile"></el-option> -->
    <!-- <el-option label="> 10° percentile" value="> 10° percentile"></el-option> -->
    <!-- <el-option label="> 97° percentile" value="> 97° percentile"></el-option> -->
  </el-select>
</div>
</div>

<div class="row pad" style="margin-top:24px;">
<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Esito</div>
<div class="col s3">
   <el-select v-model="isFdisp" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option label="Nessuna preferenza" :value="-1"></el-option>
    <el-option label="Dimessi al domicilio" :value="1"></el-option>
  </el-select>
</div>


</div>



<div class="yo-text-l yo-color-primary" style="margin-top:24px;">IL TUO CENTRO</div>

<div class="row pad" style="margin-top:24px;">
<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Anno</div>
<div class="col s3">
   <el-select v-model="isByear" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option v-for="item in anni" :key="item.value" :label="item.label" :value="item.value"></el-option>
  </el-select>
</div>

</div>


<div class="yo-text-l yo-color-primary" style="margin-top:24px;">NETWORK DI CONFRONTO</div>

<div class="row pad" style="margin-top:24px;">
<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Network di confronto</div>
<div class="col s3">
   <el-select v-model="isConfronto" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option label="Tutto il Network" :value="'network'"></el-option>
    <el-option label="La tua regione" value="regione"></el-option>
    <!--
    <el-option label="Nord" value="nord"></el-option>
    <el-option label="Centro" value="centro"></el-option>
    <el-option label="Sud" value="sud"></el-option>
    <el-option label="Il tuo centro" value="centro"></el-option>
    <el-option label="La tua regione" value="regione"></el-option>
    -->
  </el-select>
</div>


<div class="col s3 yo-valign-text-center yo-align-right" style="height:40px;">Anno</div>
<div class="col s3">
   <el-select v-model="isByearConfronto" placeholder="Select" style="width:100%;" v-on:change="filterChange">
    <el-option v-for="item in anni" :key="item.value" :label="item.label" :value="item.value"></el-option>
  </el-select>
</div>

</div>



<div class="yo-text-l red" style="margin-top:24px;">HELP</div>

Selezionare i filtri e il network di confronto e poi selezionare la sezione di proprio interesse cliccando sulle icone in alto a destra.
<br />
Le variabili in blu sono per i soli  neonati di EG minore o uguale a 31 settimane o con peso  minore di 1500 g

</div>


<div v-if="tabShow=='dati-generali'" class="report_basico">
<div class="yo-text-n yo-color-primary" style="margin:24px 0 12px 0;">Le variabili riportate in blu sono valide solo per i neonati di EG minore o uguale a 31 settimane o con peso nascita minore o uguale a 1500g</div>
<div class="row white yo-bg-color-primary">
   <div class="col s4 yo-align-center  yo-valign-text-center" style="height:42px;border-right:2px solid white;padding-top:8px;padding-bottom:8px;">
      VARIABILE
   </div>
   <div class="col s4 yo-align-center  yo-valign-text-center" style="height:42px;border-left:2px solid white;border-right:2px solid white;padding-top:8px;padding-bottom:8px;">
      IL TUO CENTRO ({{isByear}})
   </div>
   <div class="col s4 yo-align-center yo-valign-text-center" style="height:42px;border-left:2px solid white;padding-top:8px;padding-bottom:8px;">
      {{labelConfronto}} ({{isByearConfronto}})
   </div>
</div>   



<report :tbName="tbName" variabile="sex"></report>
<report :tbName="tbName" variabile="primogenito"></report>
<report :tbName="tbName" variabile="locate"></report>
<report :tbName="tbName" variabile="deldie"></report>
<report :tbName="tbName" variabile="gaweeks"></report>
<report :tbName="tbName" variabile="bwgt"></report>
<report :tbName="tbName" variabile="sga"></report>
<report :tbName="tbName" variabile="lunghezzanascita"></report>
<report :tbName="tbName" variabile="bheadcir"></report>
<report :tbName="tbName" variabile="etamaterna"></report>

<div class="yo-text-l red" style="margin-top:24px;">LEGENDA</div>
» Q1 indica il I quartile  
<br />
» Q3 indica il III quartile
<br />
» Q3-Q1 indica la differenza tra il terzo e il primo quartile
</div>

<div v-if="tabShow=='dati-perinatali'" class="report_basico" >
<div class="yo-text-n yo-color-primary" style="margin:24px 0 12px 0;">Le variabili riportate in blu sono valide solo per i neonati di EG minore o uguale a 31 settimane o con peso nascita minore o uguale a 1500g</div>
<div class="row white yo-bg-color-primary">
   <div class="col s4 yo-align-center  yo-valign-text-center" style="height:42px;border-right:2px solid white;padding-top:8px;padding-bottom:8px;">
      VARIABILE
   </div>
   <div class="col s4 yo-align-center  yo-valign-text-center" style="height:42px;border-left:2px solid white;border-right:2px solid white;padding-top:8px;padding-bottom:8px;">
      IL TUO CENTRO ({{isByear}})
   </div>
   <div class="col s4 yo-align-center yo-valign-text-center" style="height:42px;border-left:2px solid white;padding-top:8px;padding-bottom:8px;">
      {{labelConfronto}} ({{isByearConfronto}})
   </div>
</div>   
<report :tbName="tbName" variabile="pcare" ></report>
<report :tbName="tbName" variabile="patomadre" ></report>
<report :tbName="tbName" variabile="patomadretipo" ></report>
<report :tbName="tbName" variabile="pma" ></report>
<report :tbName="tbName" variabile="mhypertens" ></report>
<report :tbName="tbName" variabile="mdiabetes" ></report>
<report :tbName="tbName" variabile="aster" ></report>
<report :tbName="tbName" variabile="tipoaster" ></report>
<report :tbName="tbName" variabile="amagsulf" ></report>
<report :tbName="tbName" variabile="iugr" ></report>
<report :tbName="tbName" variabile="benfetale" ></report>
<report :tbName="tbName" variabile="mult" ></report>
<report :tbName="tbName" variabile="nbirths" ></report>
<report :tbName="tbName" variabile="tttdec" ></report>
<report :tbName="tbName" variabile="multmonoc" ></report>
<report :tbName="tbName" variabile="congeninf" ></report>
<report :tbName="tbName" variabile="chorio" ></report>
<report :tbName="tbName" variabile="anomplacenta" ></report>
<report :tbName="tbName" variabile="prom" ></report>
<report :tbName="tbName" variabile="initrav" ></report>
<report :tbName="tbName" variabile="vagdel" ></report>

<div class="yo-text-l red" style="margin-top:24px;">LEGENDA</div>
» Q1 indica il I quartile  
<br />
» Q3 indica il III quartile
<br />
» Q3-Q1 indica la differenza tra il terzo e il primo quartile
</div>




<div v-if="tabShow=='sala-parto'" class="report_basico" >
<div class="yo-text-n yo-color-primary" style="margin:24px 0 12px 0;">Le variabili riportate in blu sono valide solo per i neonati di EG minore o uguale a 31 settimane o con peso nascita minore o uguale a 1500g</div>
<div class="row white yo-bg-color-primary">
   <div class="col s4 yo-align-center  yo-valign-text-center" style="height:42px;border-right:2px solid white;padding-top:8px;padding-bottom:8px;">
      VARIABILE
   </div>
   <div class="col s4 yo-align-center  yo-valign-text-center" style="height:42px;border-left:2px solid white;border-right:2px solid white;padding-top:8px;padding-bottom:8px;">
      IL TUO CENTRO ({{isByear}})
   </div>
   <div class="col s4 yo-align-center yo-valign-text-center" style="height:42px;border-left:2px solid white;padding-top:8px;padding-bottom:8px;">
      {{labelConfronto}} ({{isByearConfronto}})
   </div>
</div>  


<report :tbName="tbName" variabile="ap1"></report>
<report :tbName="tbName" variabile="ap5"></report>
<report :tbName="tbName" variabile="rianimazionedr"></report>
<report :tbName="tbName" variabile="drox"></report>
<report :tbName="tbName" variabile="drbm"></report>
<report :tbName="tbName" variabile="drlma"></report>
<report :tbName="tbName" variabile="dret"></report>
<report :tbName="tbName" variabile="drnimv"></report>
<report :tbName="tbName" variabile="drcpap"></report>
<report :tbName="tbName" variabile="sli"></report>
<report :tbName="tbName" variabile="drcc"></report>
<report :tbName="tbName" variabile="drep"></report>
<report :tbName="tbName" variabile="drsurf"></report>

<div class="yo-text-l red" style="margin-top:24px;">LEGENDA</div>
» Q1 indica il I quartile  
<br />
» Q3 indica il III quartile
<br />
» Q3-Q1 indica la differenza tra il terzo e il primo quartile
</div>  




<div v-if="tabShow=='decorso-clinico'" class="report_basico" >
<div class="yo-text-n yo-color-primary" style="margin:24px 0 12px 0;">Le variabili riportate in blu sono valide solo per i neonati di EG minore o uguale a 31 settimane o con peso nascita minore o uguale a 1500g</div>
<div class="row white yo-bg-color-primary">
   <div class="col s4 yo-align-center  yo-valign-text-center" style="height:42px;border-right:2px solid white;padding-top:8px;padding-bottom:8px;">
      VARIABILE
   </div>
   <div class="col s4 yo-align-center  yo-valign-text-center" style="height:42px;border-left:2px solid white;border-right:2px solid white;padding-top:8px;padding-bottom:8px;">
      IL TUO CENTRO ({{isByear}})
   </div>
   <div class="col s4 yo-align-center yo-valign-text-center" style="height:42px;border-left:2px solid white;padding-top:8px;padding-bottom:8px;">
      {{labelConfronto}} ({{isByearConfronto}})
   </div>
</div>  

<report :tbName="tbName" variabile="atempm"></report>
<report :tbName="tbName" variabile="atemp"></report>
<report :tbName="tbName" variabile="die12"></report>
<report :tbName="tbName" variabile="ebseps"></report>
<report :tbName="tbName" variabile="lbpath"></report>
<report :tbName="tbName" variabile="cnegstaph"></report>
<report :tbName="tbName" variabile="fungal"></report>
<report :tbName="tbName" variabile="patoresp"></report>
<report :tbName="tbName" variabile="oxy"></report>
<report :tbName="tbName" variabile="vent"></report>
<report :tbName="tbName" variabile="hfv"></report>
<report :tbName="tbName" variabile="hfnc"></report>
<report :tbName="tbName" variabile="nimv"></report>
<report :tbName="tbName" variabile="cpap"></report>
<report :tbName="tbName" variabile="cpapes"></report>
<report :tbName="tbName" variabile="surfx"></report>
<report :tbName="tbName" variabile="surf1dhr"></report>
<report :tbName="tbName" variabile="surf1dmin"></report>
<report :tbName="tbName" variabile="fio2surf"></report>
<report :tbName="tbName" variabile="nsurf"></report>
<report :tbName="tbName" variabile="insure"></report>
<report :tbName="tbName" variabile="lisa"></report>
<report :tbName="tbName" variabile="prelisa"></report>
<report :tbName="tbName" variabile="tipoprelisa"></report>
<report :tbName="tbName" variabile="ino"></report>
<report :tbName="tbName" variabile="newox28"></report>
<report :tbName="tbName" variabile="ox36"></report>
<report :tbName="tbName" variabile="vent36"></report>
<report :tbName="tbName" variabile="hfv36"></report>
<report :tbName="tbName" variabile="hfnc36"></report>
<report :tbName="tbName" variabile="nimv36"></report>
<report :tbName="tbName" variabile="cpap36"></report>
<report :tbName="tbName" variabile="sterbpd"></report>
<report :tbName="tbName" variabile="bpd"></report>
<report :tbName="tbName" variabile="bpdgrado"></report>
<report :tbName="tbName" variabile="apnea"></report>
<report :tbName="tbName" variabile="ttn"></report>
<report :tbName="tbName" variabile="rds"></report>
<report :tbName="tbName" variabile="pntx"></report>
<report :tbName="tbName" variabile="usound1"></report>
<report :tbName="tbName" variabile="ugrade1"></report>
<report :tbName="tbName" variabile="pvl"></report>
<report :tbName="tbName" variabile="pvlgrado"></report>
<report :tbName="tbName" variabile="eii"></report>
<report :tbName="tbName" variabile="ipotermia"></report>
<report :tbName="tbName" variabile="eyex"></report>
<report :tbName="tbName" variabile="istage"></report>
<report :tbName="tbName" variabile="ropantivegf"></report>
<report :tbName="tbName" variabile="ropsurg"></report>
<report :tbName="tbName" variabile="pda"></report>
<report :tbName="tbName" variabile="ibuprofen"></report>
<report :tbName="tbName" variabile="acetamin"></report>
<report :tbName="tbName" variabile="indometh"></report>
<report :tbName="tbName" variabile="pdasurg"></report>
<report :tbName="tbName" variabile="nec"></report>
<report :tbName="tbName" variabile="giperf"></report>
<report :tbName="tbName" variabile="necsurg"></report>
<report :tbName="tbName" variabile="cmal"></report>
<report :tbName="tbName" variabile="osurg"></report>
<report :tbName="tbName" variabile="npgg"></report>
<report :tbName="tbName" variabile="negg"></report>
<report :tbName="tbName" variabile="inizionegg"></report>
<report :tbName="tbName" variabile="neconlm"></report>
<report :tbName="tbName" variabile="neconla"></report>
<report :tbName="tbName" variabile="neconlm_la"></report>
<report :tbName="tbName" variabile="lmbanca"></report>
<report :tbName="tbName" variabile="lmfortificato"></report>
<report :tbName="tbName" variabile="digiuno"></report>
<report :tbName="tbName" variabile="fef"></report>
<report :tbName="tbName" variabile="fefgg"></report>
<report :tbName="tbName" variabile="probiotics"></report>
<report :tbName="tbName" variabile="colestasi"></report>
<report :tbName="tbName" variabile="epo"></report>
<report :tbName="tbName" variabile="ec"></report>
<report :tbName="tbName" variabile="caffeine"></report>
<report :tbName="tbName" variabile="tcaffeine"></report>
<report :tbName="tbName" variabile="gginicaffeine"></report>
<report :tbName="tbName" variabile="vitamina"></report>

<div class="yo-text-l red" style="margin-top:24px;">LEGENDA</div>
» Q1 indica il I quartile  
<br />
» Q3 indica il III quartile
<br />
» Q3-Q1 indica la differenza tra il terzo e il primo quartile
</div>  




<div v-if="tabShow=='dimissione'" class="report_basico" >
<div class="yo-text-n yo-color-primary" style="margin:24px 0 12px 0;">Le variabili riportate in blu sono valide solo per i neonati di EG minore o uguale a 31 settimane o con peso nascita minore o uguale a 1500g</div>
<div class="row white yo-bg-color-primary">
   <div class="col s4 yo-align-center  yo-valign-text-center" style="height:42px;border-right:2px solid white;padding-top:8px;padding-bottom:8px;">
      VARIABILE
   </div>
   <div class="col s4 yo-align-center  yo-valign-text-center" style="height:42px;border-left:2px solid white;border-right:2px solid white;padding-top:8px;padding-bottom:8px;">
      IL TUO CENTRO ({{isByear}})
   </div>
   <div class="col s4 yo-align-center yo-valign-text-center" style="height:42px;border-left:2px solid white;padding-top:8px;padding-bottom:8px;">
      {{labelConfronto}} ({{isByearConfronto}})
   </div>
</div>  

<report :tbName="tbName" variabile="los1"></report>
<report :tbName="tbName" variabile="fdisp"></report>
<report :tbName="tbName" variabile="entfeed"></report>
<report :tbName="tbName" variabile="supportodim"></report>
<report :tbName="tbName" variabile="oxfinal"></report>
<report :tbName="tbName" variabile="ventfinal"></report>
<report :tbName="tbName" variabile="hfvfinal"></report>
<report :tbName="tbName" variabile="hfncfinal"></report>
<report :tbName="tbName" variabile="nimvfinal"></report>
<report :tbName="tbName" variabile="cpapfinal"></report>
<report :tbName="tbName" variabile="acfinal"></report>
<report :tbName="tbName" variabile="dwgt"></report>
<report :tbName="tbName" variabile="dheadcir"></report>
<report :tbName="tbName" variabile="ldimissione"></report>

<div class="yo-text-l red" style="margin-top:24px;">LEGENDA</div>
» Q1 indica il I quartile  
<br />
» Q3 indica il III quartile
<br />
» Q3-Q1 indica la differenza tra il terzo e il primo quartile
</div>  






<div v-if="tabShow=='trasferimento'" class="report_basico" >
<div class="yo-text-n yo-color-primary" style="margin:24px 0 12px 0;">Le variabili riportate in blu sono valide solo per i neonati di EG minore o uguale a 31 settimane o con peso nascita minore o uguale a 1500g</div>
<div class="row white yo-bg-color-primary">
   <div class="col s4 yo-align-center  yo-valign-text-center" style="height:42px;border-right:2px solid white;padding-top:8px;padding-bottom:8px;">
      VARIABILE
   </div>
   <div class="col s4 yo-align-center  yo-valign-text-center" style="height:42px;border-left:2px solid white;border-right:2px solid white;padding-top:8px;padding-bottom:8px;">
      IL TUO CENTRO ({{isByear}})
   </div>
   <div class="col s4 yo-align-center yo-valign-text-center" style="height:42px;border-left:2px solid white;padding-top:8px;padding-bottom:8px;">
      {{labelConfronto}} ({{isByearConfronto}})
   </div>
</div>  

<report :tbName="tbName" variabile="transcode"></report>
<report :tbName="tbName" variabile="f2disp"></report>
<report :tbName="tbName" variabile="lostot"></report>

<div class="yo-text-l red" style="margin-top:24px;">LEGENDA</div>
» Q1 indica il I quartile  
<br />
» Q3 indica il III quartile
<br />
» Q3-Q1 indica la differenza tra il terzo e il primo quartile
</div>  


</div>
</div>
</template>

<script>
import report from './Report-basico-variabile.vue'
export default {
components: {
   report
},
data() {
   return {
      loading:{}
      ,ready: false
      ,needReload: false
      ,item:{}
      ,tabShow: 'filter'
      ,testnow: 'mirko'
      ,tbName: ''

      ,isByear: 2022
      ,isBwgt: [200,5000]
      ,isGaweeks:[14,46]
      ,isSex: -1
      ,isLocate: -1
      ,isIugr: -1
      ,isMult: -1
      ,isSga: -1
      ,isFdisp: -1


      ,isConfronto: 'network'
      ,isByearConfronto: 2022

      ,anni: [{label:"2024", value:2024},{label:"2023", value:2023},{label:"2022", value:2022},{label:"2021", value:2021},{label:"2020", value:2020},{label:"2019", value:2019}]
      ,bwgtMarks:{200: '200gr',500: '500gr', 1000: '1kg', 2000: '2kg', 3000: '3kg', 4000: '4kg', 5000: '5kg'}
      ,gaweeksMarks:{14: '14',20: '20',28: '28', 36: '36', 46: '46'}
   }
},
created () {
   this.pulisciTabelle()
   this.tbName = '_'+this.$moment().format('YYYY-MM-DD H')+'_'+this.$centro.referente.row.centro+'_'+this.$teras.random()
   console.log(this.tbName)
   this.rCentro ()
},
async destroyed() {
    await this.$axios.query('doQuery','DROP TABLE IF EXISTS `r←tbName`, `r←tbNamec`;',{tbName: this.tbName})
},
methods: {
   async pulisciTabelle(){
      /* ELIMINO LE TABELLE RIMASTE APERTE */
      let tabelle = await this.$axios.query('fetchCol',"SHOW FULL TABLES LIKE 'r_2020%';",{})
      let tbData 
      for (let tabella  of tabelle.result){
         tbData = tabella.split('_')
         tbData = this.$moment(tbData[1]).add(24, 'hours')
         if(tbData.isBefore(this.$moment())) 
            await this.$axios.query('doQuery','DROP TABLE IF EXISTS `r←tbName`, `←tabella`;',{tabella: tabella})
      }
   },
   filterChange(val){
      console.log("Change isBwgt "+val)
      this.needReload = true
   },
   async rCentro () {
      this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
      await this.$axios.query('fetchAll','CALL report_paziente_centro(→tbName, ←isCentro, ←isByear, ←isBwgtL, ←isBwgtU, ←isGaweeksL, ←isGaweeksU, ←isSex, ←isLocate, ←isIugr, ←isMult, →isSga, →isFdisp);',{
         tbName: this.tbName
         ,isCentro:this.$centro.referente.row.centro
         ,isByear:this.isByear
         ,isBwgtL:this.isBwgt[0]
         ,isBwgtU:this.isBwgt[1]
         ,isGaweeksL:this.isGaweeks[0]
         ,isGaweeksU:this.isGaweeks[1]
         ,isSex:this.isSex
         ,isLocate:this.isLocate
         ,isIugr:this.isIugr
         ,isMult:this.isMult
         ,isSga:this.isSga
         ,isFdisp:this.isFdisp
      })

      await this.$axios.query('fetchAll','CALL report_paziente_centro_confronto(→tbName, →isConfronto, ←isCentro, ←isByear, ←isBwgtL, ←isBwgtU, ←isGaweeksL, ←isGaweeksU, ←isSex, ←isLocate, ←isIugr, ←isMult, →isSga, →isFdisp);',{
         tbName: this.tbName
         ,isConfronto:this.isConfronto
         ,isCentro:this.$centro.referente.row.centro
         ,isByear:this.isByearConfronto
         ,isBwgtL:this.isBwgt[0]
         ,isBwgtU:this.isBwgt[1]
         ,isGaweeksL:this.isGaweeks[0]
         ,isGaweeksU:this.isGaweeks[1]
         ,isSex:this.isSex
         ,isLocate:this.isLocate
         ,isIugr:this.isIugr
         ,isMult:this.isMult
         ,isSga:this.isSga
         ,isFdisp:this.isFdisp
      })
      console.log("*******************************")
      //await this.$axios.query('fetchAll','SELECT * FROM ←rTable;',{rTable:this.rTable})
      this.loading.close()
      this.ready = true

   },
   async changeTab(tab){
      if(this.needReload && tab!='filter'){
         console.log("NEED RELOAD")
         this.ready = false
         await this.rCentro ()
         this.needReload = false
      }
      this.tabShow = ''
      setTimeout(()=>{this.tabShow=tab}, 500)
      

   }
},
computed:{
   rTable:function(){      
      return 'r' + this.$centro.referente.row.centro
   },
   labelScheda: function(){
      let label = 'Non trovata'
      switch(this.tabShow){
         case 'filter':
         label = "Filtri"
         break;
         case 'dati-generali':
         label = "Scheda Dati Generali"
         break;
         case 'dati-perinatali':
         label = "Scheda Dati Prinatali"
         break;
         case 'sala-parto':
         label = "Scheda Sala Parto"
         break;
         case 'decorso-clinico':
         label = "Scheda Decorso Clinico"
         break;
         case 'dimissione':
         label = "Scheda Dimissione"
         break;
         case 'trasferimento':
         label = "Scheda Transferimento"
         break;
      }
      return label
   },
   labelSex: function(){
      let label = 'Non trovata'
      switch(this.isSex){
         case 1:
         label = "Maschi"
         break;
         case 0:
         label = "Femmine"
         break;
         case 9:
         label = "Sesso Indeterminato"
         break;
      }
      return label
   },
   labelLocate: function(){
      let label = 'Non trovata'
      switch(this.isLocate){
         case 0:
         label = "InBorn"
         break;
         case 1:
         label = "OutBorn"
         break;
      }
      return label
   },
   labelIugr: function(){
      let label = 'Non trovata'
      switch(this.isIugr){
         case 0:
         label = "IUGR no"
         break;
         case 1:
         label = "IUGR si"
         break;
      }
      return label
   },
   labelMult: function(){
      let label = 'Non trovata'
      switch(this.isMult){
         case 0:
         label = "Gestazione multipla no"
         break;
         case 1:
         label = "Gestazione multipla si"
         break;
      }
      return label
   },
   labelSga: function(){
      let label = 'Non trovata'
      switch(this.isSga){
         case '< 3° percentile':
         label = "SGA < 3°"
         break;
         case 'tra 3° e 10° percentile':
         label = "SGA tra 3° e 10°"
         break;
         case '< 3° percentile,tra 3° e 10° percentile':
         label = "SGA < 10°"
         break;
         case '> 10° percentile,> 97° percentile':
         label = "SGA > 10°"
         break;
         case '> 10° percentile':
         label = "SGA > 10°"
         break;
         case '> 97° percentile':
         label = "SGA > 97°"
         break;
      }
      return label
   },
   labelFdisp: function(){
      let label = 'Non trovata'
      switch(this.isFdisp){
         case -1:
         label = "Tutti"
         break;
         case 1:
         label = "Dimessi al domicilio"
         break;
      }
      return label
   },
   labelConfronto: function(){
      let label = 'Non trovata'
      switch(this.isConfronto){
         case 'network':
         label = "TUTTO IL NETWORK"
         break;
         case 'regione':
         label = "LA TUA REGIONE"
         break;
         case 1:
         label = "Gestazione multipla si"
         break;
      }
      return label
   }
}
}
</script>


<style >
.report_basico .vRow{
    background: #BDD1E8;
    background: #fbeafa;

}

.report_basico .vRow:nth-child(odd) {
    color: grey;
    background: #d7e5f7;
}
</style>
